import { render, staticRenderFns } from "./galleries.html?vue&type=template&id=70e5fc8e&scoped=true&external"
import script from "./Galleries.vue?vue&type=script&lang=js"
export * from "./Galleries.vue?vue&type=script&lang=js"
import style0 from "./Galleries.vue?vue&type=style&index=0&id=70e5fc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e5fc8e",
  null
  
)

export default component.exports